<template>
  <div
    ref="kt_modal_erro_nfe"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_erro_nfe"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div
            class="notice d-flex w-100 bg-light-danger rounded border-danger border border-dashed p-6"
          >
            <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
              <inline-svg src="media/icons/duotune/general/gen040.svg" />
            </span>
            <div class="d-flex flex-stack flex-grow-1">
              <div class="fw-bold">
                <h4 class="text-gray-800 fw-bolder">
                  Ocorreu um erro ao transmitir!
                </h4>
                <div class="fs-6 text-gray-600">
                  Verifique os erros abaixo e realize a correção antes de
                  transmitir novamente.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body m-0 p-0">
          <div v-if="this.exibirFormatado" class="table-responsive m-2">
            <table
              class="table align-middle table-row-dashed fs-6 gy-2 gs-2 text-gray-600 fw-bold dataTable no-footer table-hover"
            >
              <tbody>
                <template v-if="this.erroFormatado.length > 0">
                  <template v-for="(erro, i) in this.erroFormatado" :key="i">
                    <tr>
                      <td class="align-middle">
                        <div>
                          <span class="svg-icon svg-icon-2qx svg-icon-dark">
                            <inline-svg
                              src="media/icons/duotune/general/gen040.svg"
                            />
                          </span>
                        </div>
                      </td>
                      <td class="ps-0">
                        <div class="min-w-150px align-middle">
                          <div>
                            <span class="text-dark text-hover-primary mb-1">
                              {{ erro.erroFormatado }}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="min-w-125px pe-3 text-end">
                        <button
                          @click="this.verificarAjuda(erro)"
                          type="button"
                          class="btn btn-sm btn-secondary"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/general/gen046.svg" /></span
                          >Ajuda
                        </button>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
          <div v-else>
            <textarea
              class="form-control border-0"
              style="height: 350px"
              v-model="this.erroOriginalView"
              readonly
            />
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <div class="justify-content-end">
            <!-- <button
              v-if="!this.exibirFormatado"
              class="btn btn-secondary svg-icon-white mb-2 ms-2"
              @click="this.verificarAjuda(this.erroOriginalView)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen046.svg"
                  class="me-2"
                />Ajuda
              </span>
            </button> -->
            <button
              class="btn btn-light-primary svg-icon-white mb-2 ms-2"
              @click="this.exibirFormatado = !this.exibirFormatado"
            >
              <span class="svg-icon svg-icon-1" v-if="this.exibirFormatado">
                <inline-svg
                  src="media/icons/duotune/communication/com012.svg"
                  class="me-2"
                />Mensagem original
              </span>
              <span class="svg-icon svg-icon-1" v-else>
                <inline-svg
                  src="media/icons/duotune/text/txt010.svg"
                  class="me-2"
                />Mensagem formatada
              </span>
            </button>
            <button
              class="btn btn-danger svg-icon-white mb-2 ms-2"
              @click="fechar()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Ok
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalAjudaNFe'"
    :mensagem="'Consultando a nossa Inteligência Artificial para obter a melhor ajuda possível'"
    v-if="this.loading === true"
  ></LoadingModal>
  <HelpModal
    v-if="this.exbirMensagemHelpModal"
    :nomeRef="'helpModalErroNFe'"
    :mensagem="this.mensagemRetorno"
    @exibirHelpModal="this.exibirModalHelp"
  ></HelpModal>
</template>

<script>
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import HelpModal from "@/components/modals/general/HelpModal.vue";

export default {
  components: {
    LoadingModal,
    HelpModal,
  },
  emits: ["exibirModalErroNFe"],
  props: {
    erroOriginal: { type: String, required: true },
    erroFormatado: { type: Object, required: true },
  },
  methods: {
    fechar() {
      hideModal(this.$refs.kt_modal_erro_nfe);
      this.$emit("exibirModalErroNFe", false);
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loading = true;
        getOrCreateInstanceModal(
          "loadingModalAjudaNFe",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalAjudaNFe", () => {
          this.loading = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    async exibirModalHelp(exibir) {
      if (exibir === true) {
        this.exbirMensagemHelpModal = true;
        getOrCreateInstanceModal(
          "helpModalErroNFe",
          /*open*/ () => {
            this.$utils.requestFocus("helpModalErroNFe");
          },
          /*close*/ () => {
            this.exibirModalHelp(false);
          }
        );
      } else {
        hideModalId("helpModalErroNFe", () => {
          this.exbirMensagemHelpModal = false;
        });
      }
    },
    async verificarAjuda(erro) {
      try {
        await this.exibirModalLoading(true);

        let mensagem =
          "Solução para o erro (NF-e): " +
          erro.tagErro +
          " - " +
          erro.erroFormatado;
        let result = await this.$store.dispatch("chatGPT/getChat", mensagem);
        if (result.Success === true) {
          if (result.Data) {
            this.mensagemRetorno = result.Data;
            await this.exibirModalHelp(true);
          }
        } else {
          await this.$swal.showInvalidAlert(result.Message);
        }
      } catch (error) {
        console.log(error);
      }
      await this.exibirModalLoading(false);
    },
  },
  async mounted() {
    this.erroOriginalView = this.erroOriginal;
    if (this.erroFormatado.length <= 0) {
      this.exibirFormatado = false;
    }
  },
  data() {
    return {
      loading: false,
      exibirFormatado: true,
      erroOriginalView: this.erroOriginal,
      exbirMensagemHelpModal: false,
      mensagemRetorno: "",
    };
  },
};
</script>

<style></style>
